module.exports = __webpack_public_path__ + "img/adminD 1.3fd27456.png";